<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectItem, type SelectItemProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectItemProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectItemProps>;
</script>

<template>
  <SelectItem v-bind="forwarded">
    <slot />
  </SelectItem>
</template>
